module.exports = __webpack_public_path__ + "static/media/list.78e18589.svg";